import { useEffect } from 'react';
import styled from 'styled-components';

import Icon from '@Components/design-system/icon';

interface BottomPopupProps {
  handleCloseFrame: () => void;
  width: string;
  children: React.ReactNode;
}

export default function BottomPopup(props: BottomPopupProps) {
  const { handleCloseFrame, width, children } = props;

  useEffect(() => {
    if (document.body.style.overflow === 'hidden') return;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  const handleBackdropClick = (e: React.MouseEvent<HTMLElement>) => {
    if (e.target === e.currentTarget) {
      handleCloseFrame();
    }
  };

  return (
    <section
      className='z-50 fixed w-full h-full inset-0 bg-black bg-opacity-40 flex flex-col items-center justify-end'
      onClick={handleBackdropClick}>
      <div className='flex my-3 md:w-128 px-6 w-full justify-center'>
        <div
          onClick={handleCloseFrame}
          className='cursor-pointer bg-white rounded-full p-1 w-8 h-8 flex items-center justify-center'>
          <Icon size='xs' name='close' />
        </div>
      </div>
      <Components width={width}>{children}</Components>
    </section>
  );
}

const Components = styled.div.attrs({
  className: 'bg-white py-4 overflow-y-scroll rounded-t-xl',
})<{ width: string }>`
  width: ${(props) => props.width};
  max-height: 80vh;
  @media (max-width: 768px) {
    width: 100%;
  }
`;
